import * as React from 'react';
import { styled } from '@linaria/react';

import useTickSfx from '@/hooks/use-tick-sfx';

import Demo, { DemoSliderControl } from '@/components/Demo';
import Space from '@/components/Space';

import { Svg, CodeSnippet } from './BasicShapes.shared';

const SIZE = 300;

function CenteredStrokeDemo() {
  const playTick = useTickSfx();

  return (
    <Demo
      id="centered-stroke-demo"
      outputWrapper={OutputWrapper}
      initialValues={{
        strokeWidth: 5,
      }}
      CustomGridComponent={ControlsGrid}
      controls={[
        <DemoSliderControl
          key="strokeWidth"
          id="strokeWidth"
          label="stroke-width"
          min={0}
          max={200}
          step={2}
          onChange={() => {
            playTick();
          }}
        />,
      ]}
    >
      {({ strokeWidth }) => {
        const code = `\
<svg width="${SIZE}" height="${SIZE}">
  <rect
    x="80"
    y="100"
    width="140"
    height="100"
    stroke-width="${strokeWidth}"
    stroke="green"
    fill="none"
  />
</svg>\
`;
        return (
          <Wrapper>
            <StyledCodeSnippet code={code} />

            <SvgWrapper>
              <Svg size={SIZE} fill="none">
                <rect
                  x={80}
                  y={100}
                  width={140}
                  height={100}
                  strokeWidth={strokeWidth}
                  stroke="var(--wham-complementary-500)"
                />
                <rect
                  x={80}
                  y={100}
                  width={140}
                  height={100}
                  rx={2}
                  strokeWidth={3}
                  strokeDasharray="6 5"
                  strokeLinecap="round"
                  stroke="hsl(210deg 15% 6% / 0.5)"
                />
                <rect
                  x={80}
                  y={100}
                  width={140}
                  height={100}
                  rx={2}
                  strokeWidth={1}
                  strokeDasharray="6 5"
                  stroke="white"
                  strokeLinecap="round"
                />
              </Svg>
            </SvgWrapper>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const HIDE_SNIPPET_AT = '33rem';

const OutputWrapper = styled(Space)`
  container-type: inline-size;
`;

const ControlsGrid = styled.div`
  display: grid;
  grid-template-columns: min(400px, 100%);
  justify-content: center;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  gap: 16px;
`;

const StyledCodeSnippet = styled(CodeSnippet)`
  @container (max-width: ${HIDE_SNIPPET_AT}) {
    display: none;
  }
`;

const SvgWrapper = styled.div`
  display: flex;

  @container (max-width: ${HIDE_SNIPPET_AT}) {
    position: relative;
  }
`;

export default CenteredStrokeDemo;
